import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "users__wrapper"
}
const _hoisted_2 = { class: "users" }
const _hoisted_3 = { class: "users__content" }
const _hoisted_4 = { class: "users__left" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "users__list"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "users__right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_card = _resolveComponent("user-card")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.t("users.list")), 1),
                _withDirectives(_createElementVNode("input", {
                  onKeydown: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.findUser && _ctx.findUser(...args)), ["enter"])),
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userValue) = $event)),
                  placeholder: _ctx.t('users.findUser')
                }, null, 40, _hoisted_5), [
                  [_vModelText, _ctx.userValue]
                ]),
                (_ctx.users.length > 0 && _ctx.userValue.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (item) => {
                        return (_openBlock(), _createBlock(_component_user_card, {
                          key: item.id,
                          userData: item
                        }, null, 8, ["userData"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.resPosition > 0 && _ctx.userValue.length == 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      ref: "btn",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args))),
                      class: "btn-add modal-button__run"
                    }, _toDisplayString(_ctx.t("users.showMore")), 513))
                  : _createCommentVNode("", true),
                (_ctx.foundUser != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_user_card, { userData: _ctx.foundUser }, null, 8, ["userData"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_8
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoader)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
      : (_openBlock(), _createBlock(_component_Loader, { key: 2 }))
  ], 64))
}